import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';

import PropTypes from 'prop-types';

class InputCurrency extends Component {
  static propTypes = {
    guide: PropTypes.bool,
    keepCharPositions: PropTypes.bool,
    mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
    pipe: PropTypes.func,
    placeholderChar: PropTypes.string,
    showMask: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func
  };

  render() {
    const {
      onChange,
      name,
      guide,
      keepCharPositions,
      mask,
      pipe,
      placeholderChar,
      showMask,
      ...props
    } = this.props;
    const maskedInputProps = {
      guide,
      keepCharPositions,
      mask,
      pipe,
      placeholderChar,
      showMask
    };

    return (
      <MaskedInput
        allowEmpty
        decimalSeparator=","
        id={name}
        name={name}
        onChangeEvent={onChange}
        thousandSeparator="."
        {...maskedInputProps}
        {...props}
      />
    );
  }
}

export default InputCurrency;
